module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAtCAMAAAA9SAOJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACFQTFRF/+Z//+2f//zv//bP//nf/+Rw/+mP//O//9pA/84A////ImI/WgAAAAt0Uk5T/////////////wBKTwHyAAAAh0lEQVR42uyW3Q6AIAhG6Uch3/+B25oXETEMq2XzXDrPlM+pQPIBXm/xUeE5dtmcF0gQthmDGJ/2HsnESDkn5F5ERszejEdG7iGvALNn1PcZz8xT8cw8Fa/n2fO81VPu+0PvhIpxDq28uwiCVJLnyXeWSvJU1/tBnnSdir4Afbj7npe9VYABAJZyWKi7BwzMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/newspaper.png
// module id = 1272
// module chunks = 0